import { render } from "./Change.vue?vue&type=template&id=596647c0&scoped=true"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"

import "./Change.vue?vue&type=style&index=0&id=596647c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-596647c0"

export default script